import React, { useState } from 'react';
import '../assets/styles/CandidateSearch.css'; // Make sure to create and import the CSS file

const candidates = [
    { name: 'John Doe', skills: ['JavaScript', 'React', 'Node.js'], location: 'Hyderabad', experience: '3+ years', availability: 'Immediate' },
    { name: 'Jane Smith', skills: ['Python', 'Django', 'Flask'], location: 'Mumbai', experience: '5+ years', availability: '2 weeks' },
    { name: 'Alex Johnson', skills: ['Java', 'Spring Boot', 'Hibernate'], location: 'Bengaluru', experience: '4+ years', availability: '1 month' },
    { name: 'Emily Davis', skills: ['C++', 'Qt', 'OpenGL'], location: 'Chennai', experience: '6+ years', availability: 'Immediate' },
    { name: 'Michael Brown', skills: ['Ruby', 'Rails', 'Sinatra'], location: 'Pune', experience: '2+ years', availability: '2 months' },
    // Add more candidates as needed
];

const CandidateSearch = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedExperience, setSelectedExperience] = useState('');
    const [selectedAvailability, setSelectedAvailability] = useState('');

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleExperienceChange = (event) => {
        setSelectedExperience(event.target.value);
    };

    const handleAvailabilityChange = (event) => {
        setSelectedAvailability(event.target.value);
    };

    const filteredCandidates = candidates.filter(candidate =>
        (candidate.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        candidate.skills.some(skill => skill.toLowerCase().includes(searchTerm.toLowerCase())) ||
        candidate.location.toLowerCase().includes(searchTerm.toLowerCase())) &&
        (selectedExperience === '' || candidate.experience === selectedExperience) &&
        (selectedAvailability === '' || candidate.availability === selectedAvailability)
    );

    return (
        <div className="candidate-search">
            <h2>Search for Candidates</h2>
            <div className="search-container">
                <div className="filters-column">
                    <input
                        type="text"
                        placeholder="Search by name, skills, or location"
                        value={searchTerm}
                        onChange={handleSearch}
                        className="search-input"
                    />
                    <select value={selectedExperience} onChange={handleExperienceChange} className="filter-select">
                        <option value="">Filter by Experience</option>
                        <option value="1+ years">1+ years</option>
                        <option value="2+ years">2+ years</option>
                        <option value="3+ years">3+ years</option>
                        <option value="4+ years">4+ years</option>
                        <option value="5+ years">5+ years</option>
                        <option value="6+ years">6+ years</option>
                    </select>
                    <select value={selectedAvailability} onChange={handleAvailabilityChange} className="filter-select">
                        <option value="">Filter by Availability</option>
                        <option value="Immediate">Immediate</option>
                        <option value="2 weeks">2 weeks</option>
                        <option value="1 month">1 month</option>
                        <option value="2 months">2 months</option>
                    </select>
                </div>
                <div className="results-column">
                    <div className="candidate-list">
                        {filteredCandidates.length > 0 ? (
                            filteredCandidates.map((candidate, index) => (
                                <div key={index} className="candidate-item">
                                    <h3>{candidate.name}</h3>
                                    <p><strong>Skills:</strong> {candidate.skills.join(', ')}</p>
                                    <p><strong>Location:</strong> {candidate.location}</p>
                                    <p><strong>Experience:</strong> {candidate.experience}</p>
                                    <p><strong>Availability:</strong> {candidate.availability}</p>
                                </div>
                            ))
                        ) : (
                            <p>No candidates found.</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CandidateSearch;
